<template>
  <div
    :class="{ 'pt-3': computedLabels.length > 0 }"
  >
    <div
      class="base-shadow bg-background-neutral-secondary relative w-full rounded-2xl px-4"
    >
      <LabelGroup
        v-if="computedLabels.length > 0 || isFunSunOffer"
        :labels="computedLabels"
        :is-charter-flight="isFunSunOffer"
      />
      <div
        :class="[
          'flex items-start justify-between',
          computedLabels && computedLabels.length > 0 ? 'pt-6' : 'pt-4',
        ]"
      >
        <OfferPrice
          :offer="offer"
          :offer-idx="offerIdx"
          :offer-price="offer.price.amount"
          :source="`search.offer.${offerIdx}`"
          :cashback-click-source="
            analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource
              .RESULTS
          "
          @onCashbackInfoClick="emit('onCashbackInfoClick')"
        />
        <span v-if="!isMultiTripSearch" data-favorites-card-button>
          <FavoriteButton
            :is-active="isFavorite"
            :disabled="isFavoriteDisabled"
            variant="button"
            class="shrink-0"
            @toggle="emit('onFavoriteToggle')"
          />
        </span>
      </div>

      <section class="space-y-3 pb-4 pt-3">
        <div class="space-y-2">
          <SearchCardFlight
            v-for="(flight, idx) in offer.flights"
            :key="idx"
            :offer-idx="offerIdx"
            :flight-idx="idx"
            :flight="flight"
          />
        </div>

        <div
          v-if="seatsLeft"
          class="text-text-negative-primary text-xs lowercase"
        >
          {{ t('search.seatsLeft', seatsLeft) }}
        </div>

        <slot name="bottomExtra" />
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { providerClassLib, ticketDetails } from 'shared';
  import { type flightEntity } from 'freedom-shared';

  import { searchResultCardLib } from '@/widgets/search-result-card';

  import { searchTicketsModel } from '@/features/search-tickets';
  import { LabelGroup, type Label } from '@/features/label-group';
  import { FavoriteButton } from '@/features/favorites';

  import { analyticsEventsLib } from '@/shared/lib';

  import SearchCardFlight from './SearchCardFlight.vue';
  import OfferPrice from './OfferPrice.vue';

  const { t } = useI18n();

  const props = defineProps<{
    offerIdx: number;
    offer: flightEntity.types.MappedOffer;
    isRecommendedSortingMode: boolean;
    rankingTags?: string[];
    isFavorite?: boolean;
    isFavoriteDisabled?: boolean;
    isMultiTripSearch?: boolean;
  }>();

  const emit = defineEmits<{
    onCashbackInfoClick: [];
    onFavoriteToggle: [];
  }>();

  const transportKind = computed(() =>
    ticketDetails.lib.getOfferTransportKind(props.offer),
  );
  const computedLabels = computed<Label[]>(
    () =>
      searchTicketsModel.useLabels(
        props.offer.features ?? {},
        props.isRecommendedSortingMode,
        props.rankingTags,
        transportKind.value,
      ).value,
  );
  const isFunSunOffer = computed(() =>
    providerClassLib.isFunSun(props.offer.$meta.provider_class),
  );

  const seatsLeft = computed(() =>
    searchResultCardLib.getOfferSeatsLeft(props.offer),
  );
</script>
